import { render, staticRenderFns } from "./Escenario.vue?vue&type=template&id=6fb42217"
import script from "./Escenario.vue?vue&type=script&lang=js"
export * from "./Escenario.vue?vue&type=script&lang=js"
import style0 from "./Escenario.vue?vue&type=style&index=0&id=6fb42217&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports